<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5 class="mb-20 mt-3">Nouveau bon de livraison</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row">
        <div class="col-md-12 mb-3">
          <div v-if="show" class="alert alert-danger mb-0 text-center">
            <div class="d-flex align-items-center justify-content-center">
              <i class="bi bi-bell me-2"></i>
              <span>Vous avez {{ countColis }} nouveaux colis</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <hr />
        </div>
        <div class="col-md-12 mb-3 mt-4">
          <button
            type="button"
            class="btn btn-outline-success"
            :disabled="countColis === 0 || load"
            @click="addDeliveryNote"
          >
            <i class="flaticon-plus me-2"></i>
            <div class="spinner-border" role="status" v-if="load">
              <span class="visually-hidden">Loading...</span>
            </div>

            <span>Ajouter un bon livraison</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { defineComponent, ref, onMounted } from "vue";

export default defineComponent({
  setup() {
    const show = true; // Set to true to always show the alert
    const countColis = ref(0);
    let load = false;

    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;


    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/client/ColisCount`);
        if (response && response.data) {
          countColis.value = response.data.data[0].colis_count;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    });

    async function addDeliveryNote() {
      load = true;
      try {
        const response = await api.post(`/api/auth/client/add_delivery_note`);
        if (response.data.message === "success") {
          // Assuming you use vue-router
          window.location.href = `/edit-delivery-note/${response.data.BrcRef.id}/${response.data.BrcRef.note_ref}`;
        } else {
          // Assuming you use sweetalert2
          showToast('Failed to create delivery note', 'error');
        }
      } catch (error) {
        showToast('Failed to create delivery note', 'error');
      } finally {
        load = false;
      }
    }

    return { show, countColis, load, addDeliveryNote };
  },
});
       
</script>
